import NewsCreateComponents from "../components/NewsCreate";
import useNews from "../hook/useNews";

const NewsCreate = () => {
  const newsProps = useNews();
  return <NewsCreateComponents {...newsProps} />;
};

export default NewsCreate;
